import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';

import { UserService } from '../services/user.service';
import { OverlayService } from '../services/overlay.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html'
})
export class FooterComponent implements OnInit {

    // Template Variable
    showFooter: Boolean = true
    isLoggedIn: Boolean = false
    isFooterAlt: Boolean = false
    hasSearch: Boolean = false
	noNav: Boolean = false
    currentYear: number

    constructor(
        private router: Router,
        private userService: UserService,
        private activatedRoute: ActivatedRoute,
        private overlayService: OverlayService,
    ) {
        this.currentYear = new Date().getFullYear()
        this.isLoggedIn = this.userService.isLoggedin();
        this.router.events.filter((event) => event instanceof NavigationEnd).map(() => this.activatedRoute).map((route) => {
            this.isLoggedIn = this.userService.isLoggedin()
            while (route.firstChild) route = route.firstChild
            return route;
        }).filter((route) => route.outlet === 'primary').mergeMap((route) => route.data).subscribe((event) => {
            this.showFooter = false;
            this.isFooterAlt = false;
            this.hasSearch = false
            if (event['hasSearch']) this.hasSearch = true
            if (event['footer']) this.showFooter = true
            if (event['footerAlt']) this.isFooterAlt = true
			this.noNav = false;
			if (event['noNav']) {
				this.noNav = true;
			}
        });
    }

    ngOnInit() {
    }

    logout() {
        this.userService.logout();
    }

}



// WEBPACK FOOTER //
// ./src/app/common/footer.component.ts